import {createBox} from 'ol/interaction/Draw';
import {Stroke, Style} from 'ol/style';

import {drawModes} from '../actions/ui.js';

const getStrokeStyle = (color, dash) => {
  return new Style({
    stroke: new Stroke({
      color,
      lineDash: dash ? [4, 8] : null,
      width: 2,
    }),
  });
};

export const DRAW_INTERACTIONS = {
  [drawModes.AREA]: {
    type: 'Circle',
    freehand: true,
    style: getStrokeStyle('white'),
    geometryFunction: createBox(),
  },
};
